module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AfterSaleAgencyView.js"));
	}, "WithDrawApplyUploadView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WithDrawApplyUploadView!./src/pages/Store/BusinessManage/AfterSaleAgency/AfterSaleAgencyView.js
// module id = 1714
// module chunks = 418